// Utils
import contentStateGetTextPriorTo from '../contentState/contentStateGetTextPriorTo';

export default (editorState) =>
    contentStateGetTextPriorTo({
        contentState: editorState.getCurrentContent(),
        selection: editorState.getSelection(),
    });
